enum ExhibitFeature {
    INFORMATION = 'information',
    SPONSORSHIPS = 'sponsorships',
    NOTES = 'notes',
    QUIZZES = 'quizzes',
}

export default ExhibitFeature